import React from "react";
import "./RefundPolicy.css";

function Termsandconditions() {
    return (
        <>
            <div>
                <div className="mt-3 mb-3 container main-policy">
                    <div>
                        <div>
                            <h3 className="text-center">Terms And Conditions</h3>
                        </div>
                        <hr />

                        <h4>1. Acceptance of Terms</h4>
                        <p>By accessing and using the Voomka mobile application and website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>

                        <h4>2. Use License</h4>
                        <p>Permission is granted to temporarily download one copy of the materials on Voomka's application for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                            •Modify or copy the materials
                            •Use the materials for any commercial purpose or for any public display
                            •Attempt to reverse engineer any software contained on the application
                            •Remove any copyright or other proprietary notations from the materials</p>

                        <h4>3. Disclaimer</h4>
                        <p>The materials on Voomka's application are provided on an 'as is' basis. Voomka makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>

                        <h4>4. Limitations</h4>
                        <p>In no event shall Voomka or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Voomka's application, even if Voomka or a Voomka authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>

                        <h4>5. Privacy Policy</h4>
                        <p>Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the application, to understand our practices.</p>

                        <h4>6. Governing Law</h4>
                        <p>These terms and conditions are governed by and construed in accordance with the laws of India and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.</p>

                        <h4>7. Contact Information</h4>
                        <p>If you have any questions about these Terms and Conditions, please contact us at support@voomka.in or visit our contact page.</p>


                    </div>
                </div>
            </div>
        </>
    )
}

export default Termsandconditions